import React from "react";
import { Icon } from "../atoms";

const MODES = [
  {
    value: "horizontal",
    activeIcon: "layout-bottom-fill",
    inactiveIcon: "layout-bottom-line",
    label: "Horizontal",
  },
  {
    value: "vertical",
    activeIcon: "layout-left-fill",
    inactiveIcon: "layout-left-line",
    label: "Vertical",
  },
];

function ViewModeSwitcher({ mode = "horizontal", onChange, className = "" }) {
  return (
    <div
      className={`inline-flex items-center gap-7 ${className}`}
      role="group"
      aria-label="View mode"
    >
      {MODES.map(({ value, activeIcon, inactiveIcon, label }) => {
        const active = mode === value;
        return (
          <button
            key={value}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={active}
            onClick={() => onChange(value)}
            disabled={active}
            className={`inline-flex items-center justify-center rounded-sm border-0 bg-transparent p-0 transition-colors duration-150 ${
              active
                ? "text-primary cursor-default"
                : "text-primary hover:text-brand-accent-fg cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-info-fg"
            }`}
          >
            <Icon name={active ? activeIcon : inactiveIcon} size="md" />
          </button>
        );
      })}
    </div>
  );
}

export default ViewModeSwitcher;